import React from 'react';
import { graphql } from 'gatsby';
import ReviewHeroSection from 'components/ReviewPage/ReviewHeroSection';
import ReviewCardsSection from 'components/ReviewPage/ReviewCardsSection';
import DemoFormSection from 'components/DemoFormSection';
import useGlobalFooter from 'hooks/useGlobalFooter';
import useGlobalHeader from 'hooks/useGlobalHeader';
import SEO, { createSEO } from '../components/SEO';
import WebsiteLayout from '../layouts/websiteLayout';

const ReviewPageTemplate = props => {
  const header = useGlobalHeader();
  const footer = useGlobalFooter();

  const { contentfulReviewPage } = props.data;
  const {
    heroTitle,
    heroBackgroundColor,
    heroReviewComponent,
    cardsSectionTitle,
    cardSectionBackgroundColor,
    inPageMenu,
    sectionOne,
    sectionTwo,
    sectionThree,
    sectionFour,
    sectionFive,
    sectionSix,
    sectionSeven,
    demoFormSection,
  } = contentfulReviewPage;

  const seo = createSEO(
    {
      ...contentfulReviewPage,
      pageCategory: 'Review',
    },
    props
  );

  const sections = [
    {
      type: 'icon',
      cards: sectionOne,
    },
    {
      type: 'video',
      cards: sectionTwo,
      reverse: false,
    },
    {
      type: 'icon',
      cards: sectionThree,
    },
    {
      type: 'video',
      cards: sectionFour,
      reverse: true,
    },
    {
      type: 'icon',
      cards: sectionFive,
    },
    {
      type: 'video',
      cards: sectionSix,
      reverse: false,
    },
    {
      type: 'icon',
      cards: sectionSeven,
    },
  ];

  return (
    <WebsiteLayout
      header={header}
      footer={footer}
      hero={{ background: heroBackgroundColor }}
      backgroundColor="Blue Video"
    >
      <SEO {...seo} />
      <ReviewHeroSection
        background={heroBackgroundColor}
        title={heroTitle}
        description=""
        review={heroReviewComponent}
      />

      <ReviewCardsSection
        title={cardsSectionTitle}
        background={cardSectionBackgroundColor}
        menuText={inPageMenu}
        sections={sections}
      />

      <DemoFormSection
        backgroundColor={demoFormSection.backgroundColor}
        formTitle={demoFormSection.formTitle}
        description={demoFormSection.description.description}
        title={demoFormSection.title}
        marketoForm={demoFormSection?.form?.marketoForm}
        redirectUrl={demoFormSection.formRedirectUrl}
      />
    </WebsiteLayout>
  );
};

export default ReviewPageTemplate;

export const ReviewTemplatePageQuery = graphql`
  query ReviewTemplatePageQuery($slug: String!) {
    contentfulReviewPage(slug: { eq: $slug }) {
      id
      titleTag
      slug
      metaDescription {
        metaDescription
      }
      indexable
      canonicalUrl
      pageName
      pageTitle
      heroTitle
      heroBackgroundColor
      demoButtonTextColor
      demoButtonText
      demoButtonLinkTo
      demoButtonBackgroundColor
      cardsSectionTitle
      cardSectionBackgroundColor
      inPageMenu
      heroReviewComponent {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionOne {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionTwo {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionThree {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionFour {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionFive {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionSix {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      sectionSeven {
        ... on ContentfulAReviewFromACustomer {
          id
          author
          companyLogo {
            file {
              url
            }
          }
          companyPosition
          quote {
            quote
          }
          wistiaVideo
        }
      }
      demoFormSection {
        backgroundColor
        title
        description {
          description
        }
        formTitle
        form {
          ...InlineMarketingForm
        }
        formRedirectUrl
      }
    }
  }
`;
